import { Button, CardContainer } from 'finara-components';
import React from 'react';

interface EmptyStateProps {
  Icon?: React.ReactElement;
  title: string;
  description: string;
  showAction?: boolean;
  actionText?: string;
  onAction?: () => void;
  actionVariant?: 'black' | 'white';
  iconSize?: number;
  useCard?: boolean;
  className?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  Icon,
  title,
  description,
  showAction = false,
  actionText = 'Agregar',
  onAction,
  actionVariant = 'black',
  iconSize = 48,
  useCard = true,
  className = '',
}) => {
  const content = (
    <div className={`text-center p-8 ${className}`}>
      {Icon && (
        <div className="text-muted mb-4 flex justify-center" style={{ fontSize: iconSize }}>
          {Icon}
        </div>
      )}
      <h3 className="text-lg font-semibold text-brand-white mb-2">{title}</h3>
      <p className="text-muted mb-4">{description}</p>
      {showAction && onAction && (
        <Button variant={actionVariant} onClick={onAction}>
          {actionText}
        </Button>
      )}
    </div>
  );

  if (useCard) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <CardContainer>{content}</CardContainer>
      </div>
    );
  }

  return content;
};
